const STRINGS = {
   de: {
      "cookieConsent.category.required": "Benötigte Cookies",
      "cookieConsent.category.analytics": "Analyse-Cookies",
      "cookieConsent.category.media": "Medien-Cookies",
      "cookieDialog.title": "Cookie-Einstellungen",
      "cookieDialog.text": "Bitte wählen Sie, welche Cookies verwendet werden dürfen. Mehr Informationen finden Sie auf der Seite <a href=\"/cookies.html\">Cookies</a>.",
      "cookieDialog.cookiesPage": "Cookies",
      "cookieDialog.acceptRequired": "Benötigte akzeptieren",
      "cookieDialog.acceptAll": "Alle akzeptieren",
      "cookieSettings.toggleAll": "Alle akzeptieren",
      "cookieSettings.apply": "Übernehmen",
      "notification.settingsApplied": "Einstellungen gespeichert",
      "notification.deleteExistingManually": "Bestehende Cookies werden nicht automatisch gelöscht. Löschen Sie die Cookies in den Browser-Einstellungen.",
   }
};

export function replaceVariables(text, variables) {
   if (variables && typeof variables === "object") {
      Object.keys(variables).forEach(name => {
         const value = variables[name];
         console.log(name, value);
      });
   }
   return text;
}

export function getString(key, variables = null) {
   const language = document.documentElement.lang;
   let string = STRINGS[language][key];
   if (typeof string === "undefined") {
      console.warn(`String with key ${key} doesn't exist in language ${language}`);
      string = "";
   }
   string = replaceVariables(string, variables);
   return string;
}
